import React, { Component} from 'react';
import "./AppHeader.css";

class AppHeader extends Component {
    render() {
        return(
            <div className="AppHeader-container">
                <div className="AppHeader-subcontainer">
                    <div className="AppHeader-link">
                        Open LDAP Search
                    </div> 
                    <div className="AppHeader-link">
                        <a href="/">Search</a>
                    </div>
                    <div className="AppHeader-link">
                        <a href="/about">About</a>
                    </div>
                </div>
            </div>
        )
    }
}

export default AppHeader;